import vue from "vue";
import VueRouter from "vue-router";
import DisponibilitaAttivita from "../components/prenotazioneAttivita/DisponibilitaAttivita.vue";
import main from '../components/main/main.vue';
import Agenda from '@/components/operatore/Agenda.vue';
import Login from "@/components/operatore/Login.vue";

vue.use(VueRouter);

let mainChildren = [
  {
    path: '/prenota',
    name: 'DisponibilitaAttivita',
    component: DisponibilitaAttivita,
  },
  {
    path: '/loginoperatore',
    name: 'LoginOperatore',
    component: Login,
  },
  {
    path: '/agenda',
    name: 'Agenda',
    component: Agenda,
  },
];

const routes = [
  {
    path: '/',
    name: 'Main',
    component: main,
    children: mainChildren,
    redirect: { name: 'DisponibilitaAttivita' }
  },
  // {
  //   path: '/recuperapassword',
  //   name: 'recuperapassword',
  //   component: RecuperaPassword
  // },
  // {
  //   path: '/recuperausername',
  //   name: 'recuperausername',
  //   component: RecuperaUsername
  // },
  // {
  //   path: '/pagamentoconfermato',
  //   name: 'pagamentoconfermato',
  //   component: pagamentoConfermato,
  // },
  // {
  //   path: '/errorepagamento',
  //   name: 'errorepagamento',
  //   component: errorePagamento,
  // },
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('loginData');
  if (to.name !== 'DisponibilitaAttivita' && to.name !== 'LoginOperatore' && !token) {
    sessionStorage.clear();
    next({name: 'LoginOperatore'});
  } else {
    next();
  }
});

export default router
